import API from './PXComAPI'

export default {
  sendSimulation ({informations, simulation, lang}) {
    return API.post('/simulation', {
      informations,
      simulation,
      lang
    })
  },
  sendContactMe (contactInfos) {
    return API.post('/contact', contactInfos)
  },
  sendEmailSummary (session) {
    return API.post('/send-summary', {session})
  }
}
